import { isValid } from "../utils/utilitiesmodule";
import { ONEServiceTypeInfo, ONEServiceType } from "../utils/objects";
import moment from "moment";

export const DefaultObjectBuilder = {


    getRepository: function (type) {
        var repository = {
            id: null,
            name: '',
            type: type,
            type_name: ONEServiceTypeInfo[type].name,
            id_service_account: -2, // -1 = custom
            path: '',
            options: {}
        };

        return repository;
    },

    getServiceAccount: function (type, extraData) {
        var serviceAccount = {
            id: null,
            name: '',
            type: type,
            type_name: ONEServiceTypeInfo[type].name,
            crypted: false,
            client_id: "",
            client_secret: "",
            username: "",
            password: "",
            region: "",
            options: {}
        };

        switch (type) {
            case ONEServiceType.FTP:
                serviceAccount.url = "";
                serviceAccount.port = 21;
                serviceAccount.options.connectionType = "ftp";
                serviceAccount.options.passiveMode = false;
                serviceAccount.options.host = "";
                serviceAccount.options.SSLProvider = 0;
                serviceAccount.options.SSLStartMode = 0;
                return serviceAccount;

            case ONEServiceType.Network:
                serviceAccount.username = "";
                serviceAccount.password = "";
                serviceAccount.options.path = "";
                return serviceAccount;

            case ONEServiceType.Cloud_IperiusS3Storage:
                serviceAccount.use_ssl = true;
                return serviceAccount

            case ONEServiceType.ESXi:
                serviceAccount.url = "";
                serviceAccount.username = "";
                serviceAccount.password = "";
                return serviceAccount;


        }


        //Cloud
        if (type.isCloud()) {
            serviceAccount.region = [ONEServiceType.Cloud_AmazonS3Storage, ONEServiceType.Cloud_IperiusS3Storage, ONEServiceType.Cloud_S3CompatibleStorage].includes(serviceAccount.type) ? "" : undefined;
            //serviceAccount.auth_code = "";
            serviceAccount.url = [ONEServiceType.Cloud_IperiusS3Storage, ONEServiceType.Cloud_S3CompatibleStorage].includes(type) ? "" : undefined;;
            serviceAccount.use_ssl = [ONEServiceType.Cloud_IperiusS3Storage, ONEServiceType.Cloud_S3CompatibleStorage].includes(type) ? true : undefined;
            serviceAccount.options.signatureversion = type == ONEServiceType.Cloud_S3CompatibleStorage ? 4 : undefined;
            serviceAccount.options.appName = [ONEServiceType.Cloud_OneDrive].includes(type) ? "" : undefined;
            serviceAccount.options.tenant_id = [ONEServiceType.Cloud_OneDrive].includes(type) ? "" : undefined;
            return serviceAccount;
        }
        return serviceAccount;
        /*
                if (ONEServiceTypeInfo[type].mainType == ONEServiceType.Microsoft) {
                    serviceAccount.client_id = "";
                    serviceAccount.client_secret = "";
                    serviceAccount.region = "";
                    serviceAccount.options.appName = "";
                    serviceAccount.options.tenant_id = "";
                    serviceAccount.options.useModernAuth = true;
                    serviceAccount.options.server = "";
                    serviceAccount.options.domain = "";
                    //serviceAccount.options.IncludeChildDomains = true; //a cosa serve?
                    serviceAccount.username = "";
                    serviceAccount.password = "";
                    return serviceAccount;
                }
        
                //Email
                if (ONEServiceTypeInfo[type].mainType == ONEServiceType.Email) { // extradata è l'email provider selezionato
                    serviceAccount.type = extraData.Id;
                    serviceAccount.type_name = extraData.Name;
                    serviceAccount.url = extraData.Url;
                    serviceAccount.username = "";
                    serviceAccount.password = "";
                    serviceAccount.use_ssl = extraData.UseSSL;
                    serviceAccount.port = extraData.Port;
                    serviceAccount.options = {
                        senderAddress: "",
                        usePop3: false,
                        popUsername: "",
                        popPassword: "",
                        popServer: "",
                        popPort: 0
                    };
                    return serviceAccount;
                }
        
                //Database
                if (ONEServiceTypeInfo[type].mainType == ONEServiceType.Database) {
                    serviceAccount.url = "";
                    serviceAccount.port = type == ONEServiceType.Database_SQLServer ? 1433 : 21;
                    serviceAccount.username = "";
                    serviceAccount.password = "";
                    serviceAccount.options = {
                        useTcpIpNetLib: false,
                        usePersistSecInfo: false,
                        useIntSecSSPI: false,
                        useTrustConn: false,
                        useEncConn: false,
                        useWinAuth: true,
                    }
                    return serviceAccount;
                }
        */

    },

    getBackupJob: function (idPC) {
        return {
            id: null,
            id_computer: idPC,
            name: "",
            sources: [],
            destinations: [],
            scheduling: [],//alla creazione è un array. quando arriva in realtime dall'agent, è una stringa
            id_scheduling_policy: "",
            options: {},
        };
    },

    getRestoreSource: function (type, backup) {
        var source = {
            id: null,
            id_service_account: -2,
            type: type,
            type_name: ONEServiceTypeInfo[type].name,
            enableCompression: false,
            options: {
                archiveType: 0,
                archiveFileCustomName: "",
                useArchivePassword: false,
                archivePassword: ""
            },
        };

        switch (type) {


            case ONEServiceType.HyperV: //HyperV
                //HyperVRestoreModel
                return {
                    type: type,
                    Id: "",

                    idBackup: isValid(backup) ? backup.id : "",
                    jobName: isValid(backup) ? backup.name : "",

                    source_vmGuid: "",
                    source_vmFolder: "",
                    source_type: isValid(backup) ? backup.destinations[0].type : -1,
                    source_id_service_account: isValid(backup) ? backup.destinations[0].id_service_account : "",

                    backupType: "",
                    copyNumber: "",
                    generateNewId: true,

                    destination_vmName: "",
                    destination_vhdCustomFolder: "",

                };


            case ONEServiceType.ESXi: //ESXi
                source.folderSource = {
                    paths: [], //Lista di oggetti di tipo {path : '', type : int -> FileFolderEntityType}
                };
                source.esxiSource = null;

                source.options = {

                    //GENERALE
                    copySecurityPermissions: false,
                    recreateCompletePath: true,

                    //FILTRI
                    specifiedExtensions: "",
                    extensionsFilterAction: 0,

                    useFileSizeFilter: false,
                    fileSizeFilterAction: 0,
                    fileSizeFilterCompare: 0,
                    fileSize: 0, // in MB

                    //ESCLUSIONI
                    excludedPaths: "",
                    //excludeSubFolders: false,

                    //COMPRESSIONE
                    useArchiveCompression: false,

                    useArchiveFileCustomName: false,
                    archiveFileCustomName: "",

                    useArchivePassword: false,
                    archivePassword: "",

                    //protectionType: 0,
                    //pathsInArchive: 1, // percorso completo nello zip di default

                    //BACKUP
                    backupType: "F",
                    nCopies: 1,
                    syncronize: false, // non utilizzato
                    backupMode: "STD",
                    cbtPort: 0,
                    nOfCopies: 1,
                    autoAddNewItems: false,

                };

                break;

            case ONEServiceType.Microsoft_ExchangeOnPremises:
            case ONEServiceType.Microsoft_ExchangeOnPremisesEWS:
            case ONEServiceType.Microsoft_Exchange365:
                //return { "id": "19593ff0-5e38-446e-808c-6aa127f31940", "jobID": "", "version": "", "type": 52, "type_name": "Exchange OnLINE", "isExchangeOnline": true, "isMultipleRestore": false, "overWrite": false, "isPST": true, "source_idSA": -2, "source_path": "G:\\Exchange_Test_Veronica\\PST Destination\\v.bachetti@iperius.onmicrosoft.com.pst", "source_type": 8, "source_type_name": "FileFolder", "destination_idSA": "ab900a23-1ee5-45e2-93d7-2d4fd6a281c7", "destination_path": "kkkkkkkkkkkkkkkkkkkkkkkkkkkkk" };
                //!!!TOLTO DESTINATIONS E MAILBOXES!!!!

                var restoreSourceType;
                var restoreSourceIDSa;
                if (isValid(backup) && isValid(backup.destination_type)) {
                    restoreSourceType = backup.destination_type;
                    restoreSourceIDSa = backup.destination_idSA
                } else if (isValid(backup)) {
                    restoreSourceType = backup.destinations[0].type;
                    restoreSourceIDSa = backup.destinations[0].id_service_account;

                } else {
                    restoreSourceType = ONEServiceType.FileFolder;
                    restoreSourceIDSa = -2
                }

                return {
                    id: "",
                    idBackup: isValid(backup) ? backup.id : '',
                    backupName: isValid(backup) ? backup.name : '',
                    version: '',
                    type: type,
                    type_name: ONEServiceTypeInfo[type].name,

                    restoreType: -1,
                    index: -1,

                    source_idSA: restoreSourceIDSa,
                    source_path: "",
                    source_type: restoreSourceType,
                    source_type_name: ONEServiceTypeInfo[restoreSourceType].name,
                    source_options: {
                        nThreads: 6,
                        buffer: 150,
                        includeArchive: false,
                        includePublicFolders: false,
                        includeCalendar: false,
                        includeContacts: false,
                        includeDrafts: false,
                        includeDeletedItems: false,
                        includeInbox: true,
                        includeJunkeMails: false,
                        includeOutbox: false,
                        includeSentItems: false,
                        includeTasks: false
                    },

                    destination_idSA: isValid(backup) && backup.sources != undefined ? backup.sources[0].id_service_account : -2,
                    destination_accounts: "",
                    destination_customFolder: "Restore " + new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()

                }; /**/
            /*source.folderSource = {
                paths: [], //Lista di oggetti di tipo {path : '', type : int -> FileFolderEntityType}
            };

            source.exchangeSource = null;
            source.options.outputFormat = "PST";
            //source.options.includePublicFolders = false;
            break;*/

            case 6: // Database
            case ONEServiceType.Database_SQLServer:
                //case 61:
                source.dbSource = null;
                source.options.verifyBackup = false;
                source.options.useNativeComp = false;
                source.options.useCopyOnly = false;
                source.options.enableAppend = false;
                source.options.appendTextBkp = "";
                source.options.singleComp = false;
                source.options.backupLog = false;
                source.options.shrinkLog = false;
                source.options.alterDbRecModel = false;
                break;
        }

        return source;
    },

    getSource: function (type) {
        var source = {
            id: null,
            id_service_account: -2,
            type: type,
            type_name: ONEServiceTypeInfo[type].name,
            enableCompression: false,
            options: {
                archiveType: 0,
                archiveFileCustomName: "",
                useArchivePassword: false,
                archivePassword: ""
            },
        };

        switch (type) {
            case ONEServiceType.DriveImage: // DriveImage
                source.driveImgSource = null;
                source.options.disableDasdIo = true;
                source.options.createPCNameFolder = true;
                source.options.backupType = "F";
                source.options.nCopies = 1;
                source.options.isCBT = false;
                source.options.resetCBT = false;
                break;

            case ONEServiceType.HyperV: //HyperV
                source.hvSource = null;
                source.options.rct = 1;
                source.options.backupType = "F";
                source.options.nCopies = 1;
                source.options.autoAddNewItems = false;

                break;

            case ONEServiceType.ESXi: //ESXi
                source.esxiSource = null;
                source.options.backupMode = "STD";
                source.options.backupType = "F";
                source.options.cbtPort = 0;
                source.options.nOfCopies = 1;
                source.options.autoAddNewItems = false;
                break;

            case 5:
            case ONEServiceType.Microsoft_ExchangeOnPremises:
            case ONEServiceType.Microsoft_ExchangeOnPremisesEWS:
            case ONEServiceType.Microsoft_Exchange365:
                source.exchangeSource = null;
                source.options.outputFormat = "PST";
                //source.options.useParallelMode = true;
                source.options.backupType = "F"
                source.options.nCopies = 1
                source.options.nThreads = 6;
                source.options.nDownloadThreads = 6;
                source.options.buffer = 150;
                source.options.includeArchive = false;
                source.options.includePublicFolders = false;
                source.options.includeCalendar = false;
                source.options.includeContacts = false;
                source.options.includeDrafts = false;
                source.options.includeDeletedItems = false;
                source.options.includeInbox = true;
                source.options.includeJunkeMails = false;
                source.options.includeOutbox = false;
                source.options.includeSentItems = false;
                source.options.includeTasks = false;
                break;


            case 6: // Database
            case ONEServiceType.Database_MySQL:
            case ONEServiceType.Database_SQLServer:
                source.dbSource = null;
                source.options.verifyBackup = false;
                source.options.useNativeComp = false;
                source.options.useCopyOnly = false;
                source.options.enableAppend = false;
                source.options.appendTextBkp = "";
                source.options.singleComp = false;
                source.options.backupLog = false;
                source.options.shrinkLog = false;
                source.options.alterDbRecModel = false;
                break;

            //Questi tipi di sorgenti sono relativamente semplici,
            // quindi per praticità utilizzo lo stesso modello
            case ONEServiceType.FileFolder: // Local File/Folder
            case ONEServiceType.Microsoft_SharePoint: //sharepoint
            case ONEServiceType.Microsoft_Teams: // teams
            case ONEServiceType.Microsoft_OneDriveForBusiness: //onedrive
                source.folderSource = {
                    paths: [], //Lista di oggetti di tipo {path : '', type : int -> FileFolderEntityType}
                };
                source.options = {

                    //GENERALE
                    copySecurityPermissions: false,
                    recreateCompletePath: true,
                    nThreads: 10,

                    //FILTRI
                    specifiedExtensions: "",
                    extensionsFilterAction: 0,

                    useFileSizeFilter: false,
                    fileSizeFilterAction: 0,
                    fileSizeFilterCompare: 0,
                    fileSize: 0, // in MB

                    //ESCLUSIONI
                    excludedPaths: "",
                    //excludeSubFolders: false,

                    //COMPRESSIONE
                    useArchiveCompression: false,
                    archiveType: 0,

                    useArchiveFileCustomName: false,
                    archiveFileCustomName: "",

                    useArchivePassword: false,
                    archivePassword: "",

                    //protectionType: 0,
                    //pathsInArchive: 1, // percorso completo nello zip di default

                    //BACKUP
                    backupType: "F",
                    nCopies: 1,
                    //syncronize: false, // non utilizzato
                    //RESTORE
                    restoreCustomFolder: ""
                };
                break;

            case ONEServiceType.Network:
                source.networkSource = {
                    paths: [], //Lista di oggetti di tipo {path : '', type : int -> FileFolderEntityType}
                };
                source.options = {
                    //GENERALE
                    copySecurityPermissions: false,
                    recreateCompletePath: true,
                    nThreads: 10,

                    //FILTRI
                    specifiedExtensions: "",
                    extensionsFilterAction: 0,

                    useFileSizeFilter: false,
                    fileSizeFilterAction: 0,
                    fileSizeFilterCompare: 0,
                    fileSize: 0, // in MB

                    //ESCLUSIONI
                    excludedPaths: "",
                    //excludeSubFolders: false,

                    //COMPRESSIONE
                    useArchiveCompression: false,
                    archiveType: 0,

                    useArchiveFileCustomName: false,
                    archiveFileCustomName: "",

                    useArchivePassword: false,
                    archivePassword: "",

                    //protectionType: 0,
                    //pathsInArchive: 1, // percorso completo nello zip di default

                    //BACKUP
                    backupType: "F",
                    nCopies: 1,
                    syncronize: false, // non utilizzato
                    //RESTORE
                    restoreCustomFolder: ""

                };
                break;
        }

        return source;
    },

    getDestination: function (type, backupSource) {
        var destination = {
            id: null,
            name: '',
            type: type,
            type_name: ONEServiceTypeInfo[type].name,
            id_service_account: isValid(backupSource) ? backupSource.id_service_account : -2,
            id_repository: -2,
            path: "",
            options: {},
        };

        return destination;
    },

    //Corrisponde a ...\iperius-enterprise-agent\IperiusEWP\BackupSources\FileFolder\Model\RestoreFileModel.cs
    getRestoreFile: function (type, backup) {
        var restoreSourceType;
        var restoreSourceIDSa;
        if (isValid(backup) && isValid(backup.destination_type)) {
            restoreSourceType = backup.destination_type;
            restoreSourceIDSa = backup.destination_idSA
        } else if (isValid(backup)) {
            restoreSourceType = backup.destinations[0].type;
            restoreSourceIDSa = backup.destinations[0].id_service_account;
        } else {
            restoreSourceType = -1;//ONEServiceType.FileFolder;
            restoreSourceIDSa = -2
        }

        var restoreFile = {
            id: "", // id del job di restore
            idBackup: isValid(backup) ? backup.id : "", // id del job di backup
            backupName: isValid(backup) ? backup.name : "",
            type: type,
            type_name: ONEServiceTypeInfo[type].name,
            /**
             * 0 = Scarica dei singoli elementi
             * 1 = ricostruisci copia full
             * 2 = ricostruisci una copia specifica
             */
            restoreType: -1,
            createFolderWithBackupName: false,
            index: -1,
            source: this.getRestoreFileSource(restoreSourceType, restoreSourceIDSa),
            destination: isValid(backup) ?
                this.getDestination(type, backup.sources[0]) : this.getDestination(type, null)
        };

        return restoreFile;
    },

    getRestoreFileSource: function (restoreSourceType, restoreSourceIDSa) {
        var restoreFileSource = {
            id_service_account: restoreSourceIDSa,
            type: restoreSourceType,
            type_name: restoreSourceType == -1 ? "" : ONEServiceTypeInfo[restoreSourceType].name,

            paths: [],
            options: {
                //GENERALE

                //FILTRI
                specifiedExtensions: "",
                extensionsFilterAction: 0,

                useFileSizeFilter: false,
                fileSizeFilterAction: 0,
                fileSizeFilterCompare: 0,
                fileSize: 0, // in MB

                //ESCLUSIONI
                excludedPaths: "",
                //excludeSubFolders: false,

                //COMPRESSIONE
                useArchiveCompression: false,

                useArchiveFileCustomName: false,
                archiveFileCustomName: "",

                useArchivePassword: false,
                archivePassword: "",

                //protectionType: 0,
                //pathsInArchive: 1, // percorso completo nello zip di default

                //RESTORE
                restoreInOriginalPosition: true
            }
        };
        return restoreFileSource;
    },


    getPolicy: function () {
        var emptypolicy = {
            "enabled_email": false,
            "enabled_push": false,
            "id": null,
            "id_type": "",
            "name": "",
            "name_type": "",
            "computers": [],
            "groups": [],
            "jobs": [],
            "policy": {
                //scheduling
                "misfire_alert": false,
                "scheduling": [""],

                //HARDWARE MONITORING
                "threshold_duration": 60,
                "threshold_cpu": 0,
                "threshold_disk": 0,
                "threshold_ram": 0,

                //PATCH SISTEMA OPERATIVO
                "included_categories": [],
                "update_time": null,
                "reboot_auto": false,
                "reboot_time_inf": null,
                "reboot_time_sup": null
            },
        };
        return emptypolicy;
    },

    getGroup: function () {
        return {
            "address": "",
            /*
            1 = gruppo privato creato successivamente
            2 = gruppo privato di default
            3 = gruppo shared di default
            4 = gruppo shared creato successivamente
            */
            "computers": [],
            "email": "",
            "id": null,
            "id_master_account": "",
            "name": "",
            "notes": "",
            "phone_number": "",
            "users": [],
            "id_customer": ""
        };
    },

    getUser: function () {
        var user = {
            "id": null,
            "username": "",
            "firstname": "",
            "lastname": "",
            "name": "",
            "address": "",
            "level": "2",
            "computers": [],
            "ids_groups": [],
            "status": "1",
            "mfa_enabled": "false",
            "role": "User",
            "role_id": 4,
            "id_master_account": "",
            "password": "",
            "confirmPassword": ""
        };

        return user;
    },

    /**
     * apiJobs è un array di oggetti del tipo:
     *     {
        
    },
     */
    // fromAPIJobsToSocketJobs(apiJobs) {
    //     return apiJobs.map(job => {
    //         return {
    //             current_operation: "",
    //             dt_end_utc: job.dt_end_utc, // 2023-08-04T13:45:24Z -> 20230804172436
    //             dt_start_utc: job.dt_start_utc, // 2023-08-04T13:45:24Z
    //             id: job.id,
    //             isRunning: false,
    //             lastresult: job.last_result,
    //             name: job.name,
    //             processed_data: 0,
    //             processed_data_string: "0 bytes",
    //             progress: 0,
    //             scheduling: job.scheduling,
    //             type: parseInt(job.type),
    //             type_name: ONEServiceTypeInfo[job.type]
    //         };
    //     });
    // }

    getTeam: function () {
        return {
            id: null,
            name: "",
            users: [],//array oggetti TeamMember
            groups: []
        }
    },

    getTeamMember: function () {
        return {
            id_user: "",
            is_lead: false
        }
    },

    getTeamHostAssignment: function () {
        return {
            id_remote: "",
            id_group: ""
        }
    },

    getCustomer() {
        return {
            id: null,          // VARCHAR(40), generato server-side a creazione
            company_name: "",     // obbligatorio
            vat_number: "",     // nullable
            sdi_code: "",         // 7 char IT
            pec_email: "",
            hourly_rate: 75.00,             // null se usa la tariffa globale
            address: "",
            city: "",
            postal_code: "",
            province: "",
            country: "",
            ids_groups: []
        }
    },

    getInvoice() {
        return {
            id_customer: "",
            ticket_ids: [],
            date_to: moment().startOf('month').format("YYYY-MM-DD"),
            date_from: moment().endOf('month').format("YYYY-MM-DD"),
            external_invoice_id: "",
            //duration_minutes: 0, restituito con il generate
            //amount: 0,restituito con il generate
            //invoiced: false,restituito con il generate
            note: ""
        };
    },

    getTicket() {
        return {
            id: null,
            title: "",
            description: "",
            priority: 1,
            status: 0,

            id_user_created: "", // l'id dell'operatore che ha creato il ticket

            id_customer: "",
            id_remote: "",
            customer_notes: "",

            id_team: null,
            id_user_assigned: null,
            operator_notes: ""
        };
    },

    
}